// import library
import { useTranslation } from "react-i18next";
// import component
import { NavLink } from "react-router-dom";
import TaskSortComponent from "./Task/Sort";
import TaskFilterComponent from "./Task/Filter";

const TaskComponent = ({isActive, customerId, userTaskList}) => {
    // variables
    const { t } = useTranslation();
    return (
        <div className="relative">
            <div className="p-2 sm:p-0 bg-white sm:bg-transparent border border-white sm:border-none rounded-lg sm:rounded-none space-y-2 sm:space-y-0">
                <div className="flex sm:hidden justify-between items-center sm:space-x-2 rounded-lg">
                    <h1 className="sm:text-lg font-semibold sm:font-bold capitalize">{ t('all User Tasks')}</h1>
                    <div className="flex items-center justify-end space-x-2">
                        <TaskSortComponent />
                        <TaskFilterComponent />
                    </div>
                </div>
                <div className="block sm:hidden my-2 sm:my-4 border-t border-background-normal"></div>
                <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-2 sm:gap-4 bg-white sm:bg-transparent rounded-xl sm:rounded-none p-2 sm:p-0">
                    <NavLink to={(isActive ? `/profiles/task-templates/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed") + " rounded-xl border-gray-normal border border-dashed hidden sm:flex flex-col justify-center items-center min-h-20"}>
                        <div className="flex items-center space-x-2">
                            <img className="w-8 h-8" src="../../assets/icons/profile/plus.svg" alt="plus" />
                            <div className="font-medium capitalize">{ t("create new task")}</div>
                        </div>
                    </NavLink>
                    {(userTaskList.list.length > 0) ?
                        userTaskList.list.map((task, index) => (
                            <div key={`task${index}`}>
                                <div className="sm:rounded-xl sm:bg-white flex justify-between items-center sm:p-4">
                                    <div className="flex space-x-2 items-center">
                                        <div className="bg-blue-light rounded-xl p-2">
                                            <img className="w-6 h-6 sm:w-8 sm:h-8" src="../../assets/icons/profile/file.svg" alt="file" />
                                        </div>
                                        <div className="xl:col-span-2 space-y-0.5">
                                            <h1 className="font-semibold text-xs sm:text-sm capitalize">{task.description}</h1>
                                            <div className="capitalize text-[10px] sm:text-xs">
                                                {task.fromDate} - {task.toDate}
                                            </div>
                                            <div className="underline text-blue-normal text-xs font-semibold cursor-pointer first-letter:capitalize">
                                                <NavLink to={`/profiles/edit-task/${task.id}/${customerId}`}>
                                                    { t('edit task details')}
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                    <NavLink to={`/profiles/copy-task/${task.id}/${customerId}`}>
                                        <img src="../../assets/icons/profile/copy.svg" alt="copy" />
                                    </NavLink>
                                </div>
                                {(userTaskList.length !== (index+1)) ? <div className="my-1 border-t border-dashed border-background-normal block sm:hidden"></div> : null}
                            </div>
                        ))
                    
                    :
                        <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white block sm:hidden">
                            { t('no data available')}
                        </div>
                    }
                </div>
            </div>
            {/* create button for mobile screen */}
            <div className="fixed bottom-2 sm:hidden w-screen left-0 px-4">
                <NavLink to={(isActive ? `/profiles/task-templates/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed")}>
                    <div className="rounded-lg  p-2 text-white bg-blue-normal font-medium text-center capitalize">
                        + { t("create new task")}
                    </div>
                </NavLink>
            </div>
        </div>
    )
}

export default TaskComponent;